module.exports = __webpack_public_path__ + "56c66847febb32f409cab097bff584c4.pdf";